// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-list.table-list {
  border: 1px solid #c1bebe;
}

.plan-detail-container {
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.plan-detail-container .slider {
  flex: 1 1 auto;
}

.plan-detail-container ag-grid-angular {
  position: absolute;
  height: 100%;
  width: 100%;
}

plan-multi-chart {
  height: 100%;
  display: block;
}

.contactTypeDropDown {
  display: inline-block;
  width: 100%;
  text-align: left;
  margin-right: 5px;
}

.ctmu-container {
  display: flex;
  align-items: center;
}

.ctmu-container wfm-select {
  flex: 1 1;
  max-width: 400px;
  min-width: 100px;
}

.row.slider {
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: 1px solid #c1bebe;
}

.slide {
  width: 100%;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  flex-shrink: 0;
  /* transform: translateX(-100%); */
  transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);
  flex-basis: auto;
}

.slider.alternate .slide {
  transform: translateX(-100%);
}

.icon {
  font-size: 20px;
  vertical-align: top;
}

:host ::ng-deep button.btn-lg.no-right-margin {
  margin-right: 0;
}
:host ::ng-deep .breadcrumb {
  background-color: transparent;
  margin-bottom: 5px;
  padding: 0;
  list-style: none;
  border-radius: 4px;
  font-size: 12px;
}
:host ::ng-deep .breadcrumb > li {
  display: inline-block;
}
:host ::ng-deep .breadcrumb > li a {
  color: #0094D1;
}
:host ::ng-deep #btn-action button {
  min-width: 40px;
  padding: 0;
}
:host ::ng-deep #dropdownSettings {
  min-width: 0;
}
:host ::ng-deep #dropdownSettings:after {
  display: none;
}

.search-box {
  padding: 0;
}

.btn-rect {
  min-width: 0;
  width: 40px;
  padding: 0px;
}

.btn-group:first-of-type {
  margin-left: 0;
  margin-right: 8px;
}

.btn-group {
  margin-left: 10px;
}

:host ::ng-deep .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #fff;
  border-color: #dae2e8;
  box-shadow: 0 0 0 0 transparent;
}

wfm-task-progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

::ng-deep .plan-details-day plan-detail-clickable-header {
  display: none;
}

:host ::ng-deep .dropdown-menu {
  border-radius: 0;
  padding: 0;
}
:host ::ng-deep .dropdown-menu .dropdown-item {
  color: #888;
  padding: 0.75rem 0.75rem;
  vertical-align: middle;
  font-size: 14px;
  cursor: pointer;
}
:host ::ng-deep .dropdown-menu .dropdown-item svg {
  fill: #888;
  margin-right: 0.25rem;
}
:host ::ng-deep .dropdown-menu .dropdown-item[disabled] {
  opacity: 0.5;
}
:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover {
  background-color: #007db8;
  color: #FFF;
}
:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover svg {
  fill: #FFF;
}

.loading-indicator {
  /*  background: #ffffffd4;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;*/
}

:host ::ng-deep .ag-header-viewport, :host ::ng-deep .ag-body-viewport, :host ::ng-deep .ag-body-horizontal-scroll {
  opacity: 1;
  transition: opacity cubic-bezier(0.65, 0.05, 0.36, 1) 150ms;
}
:host ::ng-deep .data-rendering .ag-header-viewport,
:host ::ng-deep .data-rendering .ag-body-horizontal-scroll,
:host ::ng-deep .data-rendering .ag-body-viewport {
  opacity: 0;
}
:host ::ng-deep .data-rendered .ag-header-viewport,
:host ::ng-deep .data-rendered .ag-body-horizontal-scroll,
:host ::ng-deep .data-rendered .ag-body-viewport {
  opacity: 1;
}

/*:host ::ng-deep .multi-cell-edit{
  .ag-cell-range-bottom{
    border-bottom: 2px solid blue !important;
  }
  .ag-cell-range-selected-1{
    border: 1px solid blue;
  }
}*/
.toolbar-container {
  flex-wrap: nowrap;
}

.toolbar-items-left {
  flex-wrap: nowrap;
  flex: 0 1 auto;
}

.toolbar-items-center {
  flex: 1 1 auto;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
}

.toolbar-items-right {
  flex: 0 0 auto;
}

.btn-discard {
  margin-left: 8px;
}

.message-undo {
  overflow-wrap: normal;
  max-width: 200pt;
}

.toolbar-items-left p-multiSelect {
  width: 260px;
}

:host ::ng-deep .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group {
  border-color: transparent;
}

:host ::ng-deep .rollup-collapsed .ag-floating-top {
  max-height: 36px;
  min-height: 0 !important;
}

:host ::ng-deep .toolbar-container .validation-navigator {
  height: 35px;
}

.toolbar-container .btn-rect {
  width: 35px;
  height: 35px;
}

wfm-esp-no-rows-overlay {
  background: white;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/plan-detail-v5/plan-detail-v5.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/plan/plan-detail-v5/plan-detail-v5.component.scss"],"names":[],"mappings":"AAIA;EACE,yBAAA;ACHF;;ADMA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;ACHF;;ADKA;EACE,cAAA;ACFF;;ADIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ACDF;;ADIA;EACE,YAAA;EACA,cAAA;ACDF;;ADIA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;ACDF;;ADIA;EACE,aAAA;EACA,mBAAA;ACDF;;ADGA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;ACAF;;ADEA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;ACCF;;ADKA;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EAIA,yDAAA;EACA,gBAAA;ACFF;;ADIA;EACE,4BAAA;ACDF;;ADGA;EACE,eAAA;EACA,mBAAA;ACAF;;ADMM;EACE,eAAA;ACHR;ADQE;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ACNJ;ADOI;EACE,qBAAA;ACLN;ADMM;EACE,cAAA;ACJR;ADUI;EACE,eAAA;EACA,UAAA;ACRN;ADWE;EACE,YAAA;ACTJ;ADUI;EAAS,aAAA;ACPb;;ADYA;EACE,UAAA;ACTF;;ADYA;EACE,YAAA;EACA,WAAA;EACA,YAAA;ACTF;;ADWA;EACE,cAAA;EACA,iBAAA;ACRF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;ACPF;;ADUA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;ACPF;;ADUA;EACE,aAAA;ACPF;;ADUA;EACE,gBAAA;EACA,UAAA;ACPF;ADSE;EACE,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;ACPJ;ADSI;EACE,UAAA;EACA,qBAAA;ACPN;ADSI;EACE,YAAA;ACPN;ADSI;EACE,yBAAA;EACA,WAAA;ACPN;ADQM;EACE,UAAA;ACNR;;ADYA;EACA;;;;gBAAA;ACLA;;ADaE;EACE,UAAA;EACA,2DAAA;ACVJ;ADYE;;;EAGE,UAAA;ACVJ;ADYE;;;EAGE,UAAA;ACVJ;;ADaA;;;;;;;EAAA;AASA;EACE,iBAAA;ACXF;;ADaA;EACE,iBAAA;EACA,cAAA;ACVF;;ADYA;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;ACTF;;ADWA;EACE,cAAA;ACRF;;ADUA;EACE,gBAAA;ACPF;;ADUA;EACE,qBAAA;EACA,gBAAA;ACPF;;ADSA;EACC,YAAA;ACND;;ADQA;EACE,yBAAA;ACLF;;ADQA;EACE,gBAAA;EACA,wBAAA;ACLF;;ADOA;EACE,YAAA;ACJF;;ADMA;EACE,WAAA;EACA,YAAA;ACHF;;ADKA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;ACFF","sourcesContent":["@import \"src/assets/wfm_variables\";\n\n$headerDarkTextColor: #2E2E2E;\n\n.plan-list.table-list {\n  border: 1px solid $dark-border-color;\n}\n\n.plan-detail-container{\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  padding-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.plan-detail-container .slider{\n  flex: 1 1 auto;\n}\n.plan-detail-container ag-grid-angular{\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\nplan-multi-chart{\n  height: 100%;\n  display: block;\n}\n\n.contactTypeDropDown{\n  display: inline-block;\n  width: 100%;\n  text-align: left;\n  margin-right: 5px;\n}\n\n.ctmu-container{\n  display: flex;\n  align-items: center;\n}\n.ctmu-container wfm-select{\n  flex: 1 1;\n  max-width: 400px;\n  min-width: 100px;\n}\n.row.slider{\n  flex-wrap: nowrap;\n  overflow: hidden;\n  padding:0;\n  margin:0;\n  border: 1px solid $dark-border-color;\n}\n\n.slide.active{\n\n}\n.slide{\n  width: 100%;\n  padding:0;\n  margin:0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  /* transform: translateX(-100%); */\n  -webkit-transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  -moz-transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  -o-transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  flex-basis: auto;\n}\n.slider.alternate .slide{\n  transform: translateX(-100%);\n}\n.icon{\n  font-size: 20px;\n  vertical-align: top;\n}\n:host ::ng-deep {\n\n  button {\n    &.btn-lg {\n      &.no-right-margin {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .breadcrumb {\n    background-color: transparent;\n    margin-bottom: 5px;\n    padding: 0;\n    list-style: none;\n    border-radius: 4px;\n    font-size: 12px;\n    & > li {\n      display: inline-block;\n      a {\n        color: #0094D1;\n      }\n    }\n  }\n\n  #btn-action {\n    button {\n      min-width: 40px;\n      padding: 0;\n    }\n  }\n  #dropdownSettings {\n    min-width: 0;\n    &:after {display: none;}\n  }\n\n}\n\n.search-box {\n  padding: 0;\n}\n\n.btn-rect{\n  min-width: 0;\n  width:40px;\n  padding: 0px;\n}\n.btn-group:first-of-type{\n  margin-left:0;\n  margin-right:8px;\n}\n.btn-group{\n  margin-left: 10px;\n}\n\n:host ::ng-deep .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0 0 0 0 transparent;\n}\n\nwfm-task-progress{\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n::ng-deep .plan-details-day plan-detail-clickable-header{\n  display: none;\n}\n\n:host ::ng-deep .dropdown-menu {\n  border-radius: 0;\n  padding: 0;\n\n  .dropdown-item {\n    color: #888;\n    padding: 0.75rem .75rem;\n    vertical-align: middle;\n    font-size: 14px;\n    cursor: pointer;\n\n    svg {\n      fill: #888;\n      margin-right: .25rem;\n    }\n    &[disabled] {\n      opacity: 0.5;\n    }\n    &:not([disabled]):hover {\n      background-color: #007db8;\n      color: #FFF;\n      svg {\n        fill: #FFF;\n      }\n    }\n  }\n}\n\n.loading-indicator {\n/*  background: #ffffffd4;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 1;*/\n}\n:host ::ng-deep {\n\n  .ag-header-viewport,.ag-body-viewport,.ag-body-horizontal-scroll{\n    opacity: 1;\n    transition: opacity cubic-bezier(0.65, 0.05, 0.36, 1) 150ms\n  }\n  .data-rendering .ag-header-viewport,\n  .data-rendering .ag-body-horizontal-scroll,\n  .data-rendering .ag-body-viewport{\n    opacity: 0;\n  }\n  .data-rendered .ag-header-viewport,\n  .data-rendered .ag-body-horizontal-scroll,\n  .data-rendered .ag-body-viewport{\n    opacity: 1;\n  }\n}\n/*:host ::ng-deep .multi-cell-edit{\n  .ag-cell-range-bottom{\n    border-bottom: 2px solid blue !important;\n  }\n  .ag-cell-range-selected-1{\n    border: 1px solid blue;\n  }\n}*/\n\n.toolbar-container{\n  flex-wrap: nowrap;\n}\n.toolbar-items-left{\n  flex-wrap: nowrap;\n  flex: 0 1 auto;\n}\n.toolbar-items-center{\n  flex: 1 1 auto;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n}\n.toolbar-items-right{\n  flex: 0 0 auto;\n}\n.btn-discard{\n  margin-left: 8px;\n}\n\n.message-undo {\n  overflow-wrap: normal;\n  max-width: 200pt;\n}\n.toolbar-items-left p-multiSelect{\n width:260px;\n}\n:host ::ng-deep .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{\n  border-color: transparent;\n}\n\n:host ::ng-deep .rollup-collapsed .ag-floating-top{\n  max-height:36px;\n  min-height: 0 !important;\n}\n:host ::ng-deep .toolbar-container .validation-navigator{\n  height:35px;\n}\n.toolbar-container .btn-rect{\n  width:35px;\n  height:35px;\n}\nwfm-esp-no-rows-overlay{\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n",".plan-list.table-list {\n  border: 1px solid #c1bebe;\n}\n\n.plan-detail-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  padding-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.plan-detail-container .slider {\n  flex: 1 1 auto;\n}\n\n.plan-detail-container ag-grid-angular {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\nplan-multi-chart {\n  height: 100%;\n  display: block;\n}\n\n.contactTypeDropDown {\n  display: inline-block;\n  width: 100%;\n  text-align: left;\n  margin-right: 5px;\n}\n\n.ctmu-container {\n  display: flex;\n  align-items: center;\n}\n\n.ctmu-container wfm-select {\n  flex: 1 1;\n  max-width: 400px;\n  min-width: 100px;\n}\n\n.row.slider {\n  flex-wrap: nowrap;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #c1bebe;\n}\n\n.slide {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  /* transform: translateX(-100%); */\n  -webkit-transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  -moz-transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  -o-transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  flex-basis: auto;\n}\n\n.slider.alternate .slide {\n  transform: translateX(-100%);\n}\n\n.icon {\n  font-size: 20px;\n  vertical-align: top;\n}\n\n:host ::ng-deep button.btn-lg.no-right-margin {\n  margin-right: 0;\n}\n:host ::ng-deep .breadcrumb {\n  background-color: transparent;\n  margin-bottom: 5px;\n  padding: 0;\n  list-style: none;\n  border-radius: 4px;\n  font-size: 12px;\n}\n:host ::ng-deep .breadcrumb > li {\n  display: inline-block;\n}\n:host ::ng-deep .breadcrumb > li a {\n  color: #0094D1;\n}\n:host ::ng-deep #btn-action button {\n  min-width: 40px;\n  padding: 0;\n}\n:host ::ng-deep #dropdownSettings {\n  min-width: 0;\n}\n:host ::ng-deep #dropdownSettings:after {\n  display: none;\n}\n\n.search-box {\n  padding: 0;\n}\n\n.btn-rect {\n  min-width: 0;\n  width: 40px;\n  padding: 0px;\n}\n\n.btn-group:first-of-type {\n  margin-left: 0;\n  margin-right: 8px;\n}\n\n.btn-group {\n  margin-left: 10px;\n}\n\n:host ::ng-deep .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0 0 0 0 transparent;\n}\n\nwfm-task-progress {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n::ng-deep .plan-details-day plan-detail-clickable-header {\n  display: none;\n}\n\n:host ::ng-deep .dropdown-menu {\n  border-radius: 0;\n  padding: 0;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item {\n  color: #888;\n  padding: 0.75rem 0.75rem;\n  vertical-align: middle;\n  font-size: 14px;\n  cursor: pointer;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item svg {\n  fill: #888;\n  margin-right: 0.25rem;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item[disabled] {\n  opacity: 0.5;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover {\n  background-color: #007db8;\n  color: #FFF;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover svg {\n  fill: #FFF;\n}\n\n.loading-indicator {\n  /*  background: #ffffffd4;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    z-index: 1;*/\n}\n\n:host ::ng-deep .ag-header-viewport, :host ::ng-deep .ag-body-viewport, :host ::ng-deep .ag-body-horizontal-scroll {\n  opacity: 1;\n  transition: opacity cubic-bezier(0.65, 0.05, 0.36, 1) 150ms;\n}\n:host ::ng-deep .data-rendering .ag-header-viewport,\n:host ::ng-deep .data-rendering .ag-body-horizontal-scroll,\n:host ::ng-deep .data-rendering .ag-body-viewport {\n  opacity: 0;\n}\n:host ::ng-deep .data-rendered .ag-header-viewport,\n:host ::ng-deep .data-rendered .ag-body-horizontal-scroll,\n:host ::ng-deep .data-rendered .ag-body-viewport {\n  opacity: 1;\n}\n\n/*:host ::ng-deep .multi-cell-edit{\n  .ag-cell-range-bottom{\n    border-bottom: 2px solid blue !important;\n  }\n  .ag-cell-range-selected-1{\n    border: 1px solid blue;\n  }\n}*/\n.toolbar-container {\n  flex-wrap: nowrap;\n}\n\n.toolbar-items-left {\n  flex-wrap: nowrap;\n  flex: 0 1 auto;\n}\n\n.toolbar-items-center {\n  flex: 1 1 auto;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n}\n\n.toolbar-items-right {\n  flex: 0 0 auto;\n}\n\n.btn-discard {\n  margin-left: 8px;\n}\n\n.message-undo {\n  overflow-wrap: normal;\n  max-width: 200pt;\n}\n\n.toolbar-items-left p-multiSelect {\n  width: 260px;\n}\n\n:host ::ng-deep .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group {\n  border-color: transparent;\n}\n\n:host ::ng-deep .rollup-collapsed .ag-floating-top {\n  max-height: 36px;\n  min-height: 0 !important;\n}\n\n:host ::ng-deep .toolbar-container .validation-navigator {\n  height: 35px;\n}\n\n.toolbar-container .btn-rect {\n  width: 35px;\n  height: 35px;\n}\n\nwfm-esp-no-rows-overlay {\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
